import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import Router from './Router';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './stepThree';
import QuestionsOption from './questionOption';

import { actionTypes } from './../../redux/oms/customer_select_get_kyc_profile';
import { Modal } from 'bootstrap';
import { makeStyles } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import Modalcard from './Modal';



import * as Yup from "yup";
import { Formik } from 'formik'
import { actionTypes as actionTypesNotif } from './../../redux/notificationAlert';
import { handleNotificationAlertCatch, handleNotificationAlertTryUpdate } from '../../components/method/handleNotificationAlert';
import { insert_change_oms } from '../../redux/oms/insert_change_oms';


const useStyles = makeStyles(theme => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

}));



export default function Index({ profile, open, setOpen, setflagApi }) {

    const classes = useStyles();
    const dispatch = useDispatch();

    const [indexChild, setIndexChild] = useState(0)
    const [option, setOption] = useState('')
    const [state, setstate] = useState({ national_id: '' })
    const [loading, setLoading] = useState(false)
    const [oms, setOms] = useState('rayan');

    const textError = 'فیلد اجباری می باشد'


    useEffect(() => {
        if (!open) {
            setTimeout(() => {
                setIndexChild(0)
                setstate({ national_id: '' })
            }, 500);

            dispatch({ type: actionTypes.clubmmemberCustomerKycProfileRemove })
        }

        return () => {
            dispatch({ type: actionTypes.clubmemberCustomerKycProfileRemove })
            // setIndexChild(0)
            // setstate({ national_id: '' })
        }
    }, [open])//eslint-disable-line react-hooks/exhaustive-deps 

    useEffect(() => {
        if (profile) {
            setstate({
                member_id: profile.id,
                national_id: profile.body.member_national_id
            })
        }
    }, [profile])

    const reducerProfile = useSelector(state => state.reducer_customer_get_kyc_profile)


    const apiSubmitOms = () => {

        if (loading) return
        if (Object?.keys(reducerProfile?.data)?.length === 0) return

        let national_id = reducerProfile?.data?.uniqueIdentifier
        let mobile = reducerProfile?.data?.mobile
        let privatePerson = reducerProfile?.data?.privatePerson

        let _data = {
            "member_national_id": national_id,
            "member_id": national_id,
            "mobile": mobile,
            "member_last_name": privatePerson?.lastName,
            "member_first_name": privatePerson?.firstName,
            "oms_type": oms,
            "is_option_user": option ? 'TRUE' : "FALSE"
        }


        setLoading(true)
        insert_change_oms(_data)
            .then((res) => {
                setLoading(false)
                handleNotificationAlertTryUpdate(res)

                if (res.data.response.data._id)
                    setOpen(false)
            })
            .catch(() => {
                handleNotificationAlertCatch(dispatch)
            })
            .finally(() => {

                setLoading(false)
            })

    }


    
    return (
        <Modalcard open={open} setOpen={setOpen} >
            <div className={``} >
                <Router indexChild={indexChild}>
                    <StepOne
                        state={state}
                        setState={setstate}
                        setOpen={setOpen}
                        setIndexChild={setIndexChild}
                        textError={textError}
                    />
                    <StepTwo
                        open={open}
                        state={state}
                        setOpen={setOpen}
                        textError={textError}
                        setIndexChild={setIndexChild}
                        setflagApi={setflagApi}
                    />

                    <StepThree
                        open={open}
                        setOpen={setOpen}
                        setIndexChild={setIndexChild}
                        setflagApi={setflagApi}
                        apiSubmitOms={apiSubmitOms}
                        loading={loading}
                        option={option}
                        setOption={setOption}
                        oms={oms}
                        setOms={setOms}
                    />
                    <QuestionsOption
                        handleNextStep={(handleNextStep) => { }}
                        handlePrevStep={(handlePrevStep) => { setIndexChild(perv => --perv) }}
                        national_id={state?.national_id}
                        setIndexChild={setIndexChild}
                        loadingOms={loading}
                        oms={oms}
                        apiSubmitOms={apiSubmitOms}
                    />
                </Router>
            </div>
        </Modalcard >
    )
}
